export const COLUMN_IDS = {
  RANK: 'rank',
  COMPANY_NAME: 'companyName',
  REVENUE: 'value',
}
